/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_NewInputs */

const en_email_new = /** @type {(inputs: Email_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New email`)
};

/**
* | output |
* | --- |
* | "New email" |
*
* @param {Email_NewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const email_new = /** @type {((inputs?: Email_NewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_NewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_email_new(inputs)
});